import { fmtCurrency } from "../../utils";

export default function OrderTable({
	translate,
	lang,
	eventDataArray,
	events,
	totals,
}) {
	return (
		<table style={{ marginTop: "5px" }}>
			<thead>
				<tr>
					<th> {translate(lang, `Cantidad`, `Cantidad`)} </th>
					<th className="left">
						{translate(lang, `Descripción`, `Descripción`)}
					</th>
					<th> {translate(lang, `Precio`, `Precio`)} </th>
					<th> {translate(lang, `Total`, `Total`)} </th>
				</tr>
			</thead>
			<tbody>
				{events.map((item) => {
					return (
						<tr key={item}>
							<td className="center">1</td>
							<td>{fmtEvent(eventDataArray, item, translate, lang)}</td>
							<td className="right">
								{item === "october3"
									? fmtCurrency(120000 / 100)
									: fmtCurrency(80000 / 100)}
							</td>
							<td className="right">
								{item === "october3"
									? fmtCurrency(120000 / 100)
									: fmtCurrency(80000 / 100)}
							</td>
						</tr>
					);
				})}
			</tbody>
			<tfoot>
				<tr>
					<th colSpan="3" className="right">
						{translate(lang, `SUBTOTAL`, `SUBTOTAL`)}
					</th>
					<th className="right">{fmtCurrency(totals.subtotal / 100)} </th>
				</tr>
				{events.length > 2 && (
					<tr>
						<th colSpan="3" className="right">
							{translate(lang, `3 EVENT DISCOUNT`, `DESCUENTO POR 3 EVENTOS`)}
						</th>
						<th className="right" style={{ color: "red" }}>
							({fmtCurrency(totals.discount / 100)})
						</th>
					</tr>
				)}
				<tr>
					<th colSpan="3" className="right">
						{translate(lang, `TOTAL`, `TOTAL`)}
					</th>
					<th className="right">{fmtCurrency(totals.total / 100)}</th>
				</tr>
			</tfoot>
		</table>
	);
}

const fmtEvent = (array, id, translate, lang) => {
	let name = "";
	array.forEach((item) => {
		if (item.id === id) {
			name = item.name;
		}
	});

	return translate(lang, `${name}`, `${name}`);
};
